<template>
  <div class="ly-inner">
    <idc-page-title :breadcrumbList="breadcrumbList">{{ pageTitle }}</idc-page-title>
    <!-- <table-filter /> -->
    <table-data-1 :key="Date.now()"/>
    <!-- <table-data-2 /> -->
  </div>
</template>

<script>
import IdcPageTitle from "@/components/common/IdcPageTitle";
// import TableFilter from "@/components/idcUsageStatus/powerUsageSituation/TableFilter";
import TableData1 from "@/components/idcUsageStatus/powerUsageSituation/TableData1";
import TableData2 from "@/components/idcUsageStatus/powerUsageSituation/TableData2";
export default {
  components: {
    IdcPageTitle,
    // TableFilter,
    TableData1,
    TableData2,
  },
  data() {
    return {
      custId: null,
      title : this.$route.meta.title,
      navigator : this.$route.meta.navigator
    };
  },
  computed: {
    breadcrumbList() {
      return this.navigator;
    },
    pageTitle() {
      return this.title;
    },
    i18n() {
      return this.$i18n.locale;
    },
  },
  watch: {
    i18n(newVal) {
      this.title      = (newVal === 'ko') ? this.$route.meta.title : this.$route.meta.titleEn
      this.navigator  = (newVal === 'ko') ? this.$route.meta.navigator : this.$route.meta.navigatorEn
    }
  },
  mounted() {
    this.title      = (this.i18n === 'ko') ? this.$route.meta.title : this.$route.meta.titleEn;
    this.navigator  = (this.i18n === 'ko') ? this.$route.meta.navigator : this.$route.meta.navigatorEn;
  }

};
</script>

<style lang="scss" scoped>
.ly-inner {
  text-align: left;
}
.el-pagination {
  margin-top: 20px;
}
.table {
  &-header {
    text-align: left;
    padding-bottom: 20px;
  }
  &-title {
    font-size: $--font-size-large;
    color: $--color-black;
    font-weight: $--font-weight-bold;
  }
  &-count {
    text-align: left;
    font-size: $--font-size-base;
    margin-bottom: 10px;
    span {
      font-weight: $--font-weight-bold;
    }
  }
  &-block {
    padding-top: 20px;
    &:not(:last-child) {
      padding-bottom: 40px;
    }
  }
  &-option {
    gap: 5px;
    display: flex;
    justify-content: space-between;
  }
}
.ly-table {
  padding: 20px 0;
}
</style>
